"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["INVALID_RESOURCE_TYPE"] = "INVALID_RESOURCE_TYPE";
    ErrorCodes["INVALID_YOUTUBE_LINK"] = "INVALID_YOUTUBE_LINK";
    ErrorCodes["INVALID_RESOURCE_KEY"] = "INVALID_RESOURCE_KEY";
    ErrorCodes["INVALID_MAX_QUESTIONS"] = "INVALID_MAX_QUESTIONS";
    ErrorCodes["FILE_NOT_FOUND"] = "FILE_NOT_FOUND";
    ErrorCodes["ERROR_PARSING_RESOURCE_TEXT"] = "ERROR_PARSING_RESOURCE_TEXT";
    ErrorCodes["ERROR_EXTRACTING_FILE_TEXT"] = "ERROR_EXTRACTING_FILE_TEXT";
    ErrorCodes["RESOURCE_TEXT_TOO_LONG"] = "RESOURCE_TEXT_TOO_LONG";
    ErrorCodes["RESOURCE_TEXT_TOO_SHORT"] = "RESOURCE_TEXT_TOO_SHORT";
    ErrorCodes["MISSING_RESOURCE_TEXT"] = "MISSING_RESOURCE_TEXT";
    ErrorCodes["MISSING_RESOURCE_URL"] = "MISSING_RESOURCE_URL";
    ErrorCodes["MISSING_RESOURCE_KEY"] = "MISSING_RESOURCE_KEY";
    ErrorCodes["INVALID_TAGS"] = "INVALID_TAGS";
    ErrorCodes["MAX_FREE_QUIZZES"] = "MAX_FREE_QUIZZES";
    ErrorCodes["CANNOT_FIND_SCHOOL"] = "CANNOT_FIND_SCHOOL";
    ErrorCodes["UNSYNCED_CANNOT_SHARE_WITH_SCHOOL"] = "UNSYNCED_CANNOT_SHARE_WITH_SCHOOL";
    ErrorCodes["FREE_USER_CAN_ONLY_CREATE_PUBLIC_QUIZ"] = "FREE_USER_CAN_ONLY_CREATE_PUBLIC_QUIZ";
    ErrorCodes["CANNOT_UNPUBLISH_QUIZ"] = "CANNOT_UNPUBLISH_QUIZ";
    ErrorCodes["CANNOT_UPDATE_PUBLISHED_CONTENT"] = "CANNOT_UPDATE_PUBLISHED_CONTENT";
    ErrorCodes["USER_HAVE_NO_SCHOOL"] = "USER_HAVE_NO_SCHOOL";
    ErrorCodes["USER_NOT_IN_QUIZ_SCHOOL_GROUP"] = "USER_NOT_IN_QUIZ_SCHOOL_GROUP";
    ErrorCodes["USER_NOT_IN_QUIZ_SCHOOL"] = "USER_NOT_IN_QUIZ_SCHOOL";
    ErrorCodes["NON_CREATOR_CANNOT_UPDATE_QUIZ_CONTENT"] = "NON_CREATOR_CANNOT_UPDATE_QUIZ_CONTENT";
    ErrorCodes["NON_CREATOR_CANNOT_UPDATE_PRIVATE_QUIZ"] = "NON_CREATOR_CANNOT_UPDATE_PRIVATE_QUIZ";
    ErrorCodes["INVALID_UPDATE_QUIZ_OVERVIEW_NAME"] = "INVALID_UPDATE_QUIZ_OVERVIEW_NAME";
    ErrorCodes["INVALID_UPDATE_CONTENT"] = "INVALID_UPDATE_CONTENT";
    ErrorCodes["MISSING_SCHOOL_ID"] = "MISSING_SCHOOL_ID";
    ErrorCodes["REGION_NOT_SUPPORTED"] = "REGION_NOT_SUPPORTED";
    ErrorCodes["STUDENT_NOT_ENROLLED_IN_QUIZ"] = "STUDENT_NOT_ENROLLED_IN_QUIZ";
    ErrorCodes["STUDENT_ENROLMENT_DELETED"] = "STUDENT_ENROLMENT_DELETED";
    ErrorCodes["CONTENT_TYPE_NOT_SUPPORTED"] = "CONTENT_TYPE_NOT_SUPPORTED";
    ErrorCodes["SAVED_QUIZ_CANNOT_BE_EDITED"] = "SAVED_QUIZ_CANNOT_BE_EDITED";
    ErrorCodes["TEXT_BLOCK_MODULE_PARAM_NOT_FOUND"] = "TEXT_BLOCK_MODULE_PARAM_NOT_FOUND";
    ErrorCodes["RESOURCE_TEXT_GENERATION_FAILED"] = "RESOURCE_TEXT_GENERATION_FAILED";
    ErrorCodes["MISSING_TRANSCRIPT"] = "MISSING_TRANSCRIPT";
    ErrorCodes["TRANSCRIPT_TOO_SHORT"] = "TRANSCRIPT_TOO_SHORT";
    ErrorCodes["TRANSCRIPT_TOO_LONG"] = "TRANSCRIPT_TOO_LONG";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
//# sourceMappingURL=ErrorCodes.js.map